module.exports = __webpack_public_path__ + "img/notifications-icon.c3c7799d.svg";